import DeleteMaterialPositionModal from "./DeleteMaterialPositionModal";
import { connect } from "react-redux";

import { removeMaterialPosition } from "~/store/ducks/application/materials/materials";

const mapDispatchToProps = {
  removeMaterialPosition
};

export default connect(null, mapDispatchToProps)(DeleteMaterialPositionModal);
